
import React from 'react';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import CalendlyButton from '../CalendlyButton';

interface AssessmentCompleteActionsProps {
  calendlyUrl?: string;
  onRestart: () => void;
  onExit: () => void;
  onDownloadReport: () => Promise<void>;
  personalInfo?: {
    fullName: string;
    email: string;
    company: string;
    designation: string;
  };
  assessmentTitle?: string;
  assessmentId?: string;
  pdfUrl?: string;
  isPremium?: boolean;
}

const AssessmentCompleteActions: React.FC<AssessmentCompleteActionsProps> = ({
  calendlyUrl = 'https://calendly.com/gihan-gapstars',
  onRestart,
  onExit,
  onDownloadReport,
  personalInfo,
  assessmentTitle,
  assessmentId,
  pdfUrl,
  isPremium = false
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4 border-t p-6">
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={onRestart}
          className="w-full sm:w-auto"
        >
          Retake Assessment
        </Button>
      </div>
      
      <div className="flex gap-4 w-full sm:w-auto">
        {isPremium ? (
          <Button
            onClick={onExit}
            className="w-full sm:w-auto gap-2"
          >
            <Home className="h-4 w-4" />
            Return to Dashboard
          </Button>
        ) : (
          <CalendlyButton 
            calendlyUrl={calendlyUrl}
            className="w-full sm:w-auto"
            personalInfo={personalInfo}
            assessmentTitle={assessmentTitle}
            assessmentId={assessmentId}
            pdfUrl={pdfUrl}
          />
        )}
      </div>
    </div>
  );
};

export default AssessmentCompleteActions;
